<div class="alert-dialog">
  <mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="center center">
      <div fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="center center" class="content">
        <div class="mat-h3">
          <span class="mdi mdi-alert-circle-outline color-warn"></span>
          {{data.message}}
        </div>
        <div class="mat-body width-100" [class.text-center]="data.centeredText">
          <span [innerHTML]="data.subMessage"></span>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center" class="width-100">
        <button color="primary" (click)="onSubmit(false)" mat-stroked-button>{{data.cancelLabel ?? 'Close'}}</button>
        <button color="primary" (click)="onSubmit(true)" mat-flat-button>{{data.confirmLabel ?? 'Confirm'}}</button>
      </div>
    </div>
  </mat-dialog-content>
</div>
